import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectContactServiceRequests } from 'src/store/selectors/contacts';
import ServiceRequestsTable from '../../components/ServiceRequestsTable/ServiceRequestsTable_legacy';
import { clearSearch } from 'src/store/actions/search';
import { fetchServiceRequestsListByUser } from 'src/store/actions/serviceRequests';
import { PATHS } from 'src/common/constants';
import { selectLoader } from 'src/store/selectors/loader';
import Loader from '../../components/Loader';
import { fetchContactServiceRequestCSVExportDownloadList } from 'src/store/actions/csvExport';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';

const ContactServiceRequests = ({ contact }: any) => {
  const [searchString, setSearchString] = useState('');
  const dispatch = useDispatch();

  const user = useSelector(selectAuthenticatedUser);
  const paginationCount = useSelector(
    (state: any) => state.paginationCount.count
  );
  const contactServiceRequests = useSelector((state: any) =>
    selectContactServiceRequests(state, contact.id)
  );
  const loader = useSelector(selectLoader);

  useEffect(() => {
    if (
      user.roles[0].role.name === 'Admin' ||
      user.roles[0].role.name === 'Super Admin' ||
      user.roles[0].role.name === 'Property Developer' ||
      user.roles[0].role.name === 'Strata Manager'
    ) {
      dispatch(
        fetchServiceRequestsListByUser(
          contact.id,
          contact.roles[0].role.name,
          1,
          ''
        )
      );
    } else {
      dispatch(
        fetchServiceRequestsListByUser(user.id, user.roles[0].role.name, 1, '')
      );
    }

    dispatch(clearSearch());
  }, []);

  const loadMoreServiceRequest = async () => {
    dispatch(
      fetchServiceRequestsListByUser(
        contact.id,
        contact.roles[0].role.name,
        paginationCount + 1,
        searchString
      )
    );
  };

  const search = async (text: any) => {
    setSearchString(text);

    dispatch(
      fetchServiceRequestsListByUser(
        contact.id,
        contact.roles[0].role.name,
        1,
        text,
        true
      )
    );
  };

  const downloadCSV = () => {
    dispatch(
      fetchContactServiceRequestCSVExportDownloadList(
        contact.id,
        contact.roles[0].role.name,
        searchString
      )
    );
  };

  return loader ? (
    <Loader />
  ) : (
    <ServiceRequestsTable
      download={() => downloadCSV()}
      serviceRequests={contactServiceRequests}
      onSearch={(e: any) => search(e.target.value.trim())}
      loadServiceRequest={loadMoreServiceRequest}
      from="Contact"
      navigateTo={PATHS.CONTACTS_VIEW.replace(':id', contact.id)}
    />
  );
};

export default ContactServiceRequests;
